/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button, Tooltip} from "antd";
import {CopyOutlined} from "@ant-design/icons";
import {useMessageStore} from "../../../stores/messageStore";
import {Baecha} from "../../../types/Baecha";
import {BaechaWorkDay} from "../../../types/BaechaWorkDay";

interface BaechaListPanelHeaderProps {
	baechaData?: Baecha;
	baechaWorkDayData?: BaechaWorkDay[];
	onCancelBaecha: (baechaId: string) => void;
	onClickDone?: (baechaData?: Baecha) => void;
}

const BaechaListPanelHeader = ({ baechaData, baechaWorkDayData, onCancelBaecha, onClickDone }: BaechaListPanelHeaderProps) => {
	if (!baechaData) return null;

	const { id, baechaNo, status } = baechaData;

	const getIsShowDoneBtn = () => {
		return status === 'suju';
	};

	const getIsShowBaljuCancelBtn = () => {
		if (status === 'balju') return true;
		if (status === 'suju') {
			return baechaWorkDayData?.every((item) => !item.doneDate && !item.doneMemberId);
		}
		return false;
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
			{/* 왼쪽 */}
			<div>
				{`#${baechaNo}`}
				<Tooltip title="복사" placement="right">
					<CopyOutlined
						style={{cursor: 'pointer', marginLeft: 12}}
						onClick={async () => {
							useMessageStore.setState({
								isShow: true,
								type: 'success',
								content: `복사 완료: ${baechaNo}`,
							});
							await navigator.clipboard.writeText(baechaNo.toString());
						}}
					/>
				</Tooltip>
			</div>

			{getIsShowDoneBtn() && (
				<Button
					onClick={() => onClickDone && onClickDone(baechaData)}
					style={{ marginLeft: 'auto', marginRight: '20px' }}
					color="primary"
					variant="solid"
				>
					완료 처리
				</Button>
			)}

			{/* 오른쪽 */}
			{getIsShowBaljuCancelBtn() && (
				<Button
					onClick={() => onCancelBaecha(id)}
					color="danger"
					variant="solid"
				>
					배차 취소
				</Button>
			)}
	</div>
	);
};

export default BaechaListPanelHeader;
